import blog1Image from '../../assets/blogPics/blog1.webp';
import blog2Image from '../../assets/blogPics/blog2.png';
import blog3Image from '../../assets/blogPics/blog3.webp';
import blog4Image from '../../assets/blogPics/blog4.webp';
import blog5Image from '../../assets/blogPics/blog5.png';
import nflBettingEquationImage from '../../assets/blogPics/nfl-betting-equation.png';
import omniMouseAlignmentImage from '../../assets/blogPics/omnimouse-alignment.png';
import retinaEdgeSimulationImage from '../../assets/blogPics/retina-edge-simulation.png';
import spikeSortingImage from '../../assets/blogPics/spike-sorting.png';

function mediumSearchUrl(title) {
  return `https://medium.com/search?q=${encodeURIComponent(title)}`;
}

export const BLOG_ENTRIES = [
  {
    id: 'omnimouse-dataset',
    entryNumber: '001',
    title: 'I Tried to Build Something With One of the Largest Mouse-Brain Datasets. Then I Stopped',
    shortTitle: 'What I Learned From OmniMouse',
    description:
      'A project about neural activity, behavior, and learning when not to force an experiment.',
    date: '2026-10-16',
    displayDate: 'Oct 16, 2026',
    mediumUrl:
      'https://medium.com/@hassan.alawie10/i-tried-to-build-something-with-one-of-the-largest-mouse-brain-datasets-then-i-stopped-fe55507d26e3',
    image: omniMouseAlignmentImage,
    preview: {
      label: 'OMNIMOUSE LOG',
    },
  },
  {
    id: 'nfl-betting-equation',
    entryNumber: '002',
    title: 'I Tried to Find an Edge in NFL Betting With a Two-Parameter Equation',
    shortTitle: 'The NFL Betting Equation',
    description:
      "A popular-science equation found the sportsbook's vig, then failed every test for a real edge.",
    date: '2026-10-16',
    displayDate: 'Oct 16, 2026',
    mediumUrl:
      'https://medium.com/@hassan.alawie10/i-tried-to-find-an-edge-in-nfl-betting-with-a-two-parameter-equation-6dbdddddac1f',
    image: nflBettingEquationImage,
    preview: {
      label: 'BETTING LOG',
    },
  },
  {
    id: 'retina-edge-simulation',
    entryNumber: '003',
    title: 'I Built a Tiny Simulation to Understand How the Retina Detects Edges',
    shortTitle: 'How the Retina Detects Edges',
    description:
      'I understood the individual terms: receptive fields, ON-center cells, LGN relays, and V1 simple cells. What I could not picture was how they connected.',
    date: '2026-10-11',
    displayDate: 'Oct 11, 2026',
    mediumUrl:
      'https://medium.com/@hassan.alawie10/i-built-a-tiny-simulation-to-understand-how-the-retina-detects-edges-69632499a9b7',
    image: retinaEdgeSimulationImage,
    preview: {
      label: 'RETINA LOG',
    },
  },
  {
    id: 'spike-sorting',
    entryNumber: '004',
    title: 'I Built a Spike Sorter From Scratch and Tested It Against a Real Neuron',
    shortTitle: 'Spike Sorting From Scratch',
    description:
      'Filtering, clustering, and validating a four-channel hippocampal recording against intracellular ground truth.',
    date: '2026-10-10',
    displayDate: 'Oct 10, 2026',
    mediumUrl:
      'https://medium.com/@hassan.alawie10/i-tried-spike-sorting-a-real-neuron-recording-from-scratch-6dc4c1793b3b',
    image: spikeSortingImage,
    preview: {
      label: 'SPIKE LOG',
    },
  },
  {
    id: 'tiktok-scraper',
    entryNumber: '005',
    title: 'Building a TikTok Scraper from scratch',
    shortTitle: 'TikTok Scraper',
    description:
      "I'm currently working on a website where you can find a ton of Cafe's in Toronto to promote third spaces and hanging out with your friends…",
    date: '2025-07-31',
    displayDate: 'Jul 31, 2025',
    mediumUrl: mediumSearchUrl('Building a TikTok Scraper from scratch'),
    image: blog5Image,
    preview: {
      label: 'SCRAPER LOG',
    },
  },
  {
    id: 'browser-devtools',
    entryNumber: '006',
    title: 'Debugging and Inspecting: A Guide to Browser DevTools for Beginners!',
    shortTitle: 'Browser DevTools',
    description:
      'I cannot tell you how often I open dev tools on my browser, whether it be for debugging CSS, optimizing web pages, testing…',
    date: '2024-09-19',
    displayDate: 'Sep 19, 2024',
    mediumUrl: mediumSearchUrl(
      'Debugging and Inspecting: A Guide to Browser DevTools for Beginners!'
    ),
    image: blog4Image,
    preview: {
      label: 'DEVTOOLS',
    },
  },
  {
    id: 'critical-rendering-path',
    entryNumber: '007',
    title: 'How Websites Load: A Beginner’s Guide to the Critical Rendering Path',
    shortTitle: 'Critical Rendering Path',
    description:
      'When we request a web page, the server will respond with a HTML file. Don’t believe me? Take a look at the network tab when you go on a new…',
    date: '2024-09-07',
    displayDate: 'Sep 7, 2024',
    mediumUrl: mediumSearchUrl(
      'How Websites Load: A Beginner’s Guide to the Critical Rendering Path'
    ),
    image: blog3Image,
    preview: {
      label: 'CRP ENTRY',
    },
  },
  {
    id: 'enter-url',
    entryNumber: '008',
    title: 'What happens when you enter a URL',
    shortTitle: 'Entering a URL',
    description:
      'We enter the example.com into the browser and click “Enter”. Explain to me what happens.',
    date: '2024-09-07',
    displayDate: 'Sep 7, 2024',
    mediumUrl: mediumSearchUrl('What happens when you enter a URL'),
    image: blog2Image,
    preview: {
      label: 'REQUEST FLOW',
    },
  },
  {
    id: 'debugging-css',
    entryNumber: '009',
    title: 'Debugging CSS',
    shortTitle: 'Debugging CSS',
    description:
      "I find myself constantly helping some of my peers out with CSS bugs they have, and this is just a source where I've compiled some of the…",
    date: '2024-09-06',
    displayDate: 'Sep 6, 2024',
    mediumUrl:
      'https://medium.com/%40hassan.alawie10/debugging-css-a29fa548d67b',
    image: blog1Image,
    preview: {
      label: 'CSS NOTES',
    },
  },
];
